import css from '../taskDescription.module.css'
import preview from './preview.jpeg'
import taskDescriptionTexts from '../taskDescriptionTexts'

const SeventhTypeTaskDescription = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.image} style={{ backgroundImage: `url("${preview}")` }}>
        <div className={css.imageTaskTypeNumber}>
          <p style={{ fontSize: '24px', color: '#976153' }}>8</p>
        </div>
      </div>
      <p className={css.description}>{taskDescriptionTexts[7]}</p>
    </div>
  )
}

export default SeventhTypeTaskDescription
